import axios from 'axios'

const API_PATH = 'api/v2/admins/tl_banks'

const TlBanksApiV2 = {
  /**
   * Get list of `District`
   * @param {string} bank - bank name
   * @param {string} account_number - bank account number
   * @return {object} axios response
   */
  get: async ({
    bank           = '',
    account_number = ''
  }) => {
    const params   = {
      bank           : bank,
      account_number : account_number
    }
    const response = axios.get(API_PATH, { params })
    return response
  }
}

export default TlBanksApiV2
